// @flow

// @todo: Evaluate whether needs own store: https://justlease.atlassian.net/browse/JUS-925
import type { Dispatch } from 'redux';
import { getId } from '../routes';
import { getPathname } from '../router';
import { receivedUiSettings, setUiSetting } from '../uiStore';
import { FEEDBACK_LOADING, FEEDBACK_PREFIX } from './constants';
import { getFAQFeedbackFromStorage, addFAQFeedbackToStorage } from './helpers';
import { fetchData, getFAQFeedbackUrl } from '../../helpers';
import type { FeedbackOptions, FAQFeedback } from './types';

const feedbackMap: { [string]: 'true' | 'false' } = {
  yes: 'true',
  no: 'false',
};

export const setFAQFeedback = (id: string, feedback: FeedbackOptions) => (
  (dispatch: Dispatch<*>) => {
    // Update store
    dispatch(setUiSetting(`${FEEDBACK_PREFIX}${id}`, feedback));

    // Sync store with localstorage
    addFAQFeedbackToStorage({ [`${FEEDBACK_PREFIX}${id}`]: feedback });
  }
);

export const receiveFeedbacks = (feedbacks: FAQFeedback) => (
  receivedUiSettings(feedbacks)
);

export const loadingFeedbackComplete = () => (dispatch: Dispatch<*>) => (
  dispatch(setUiSetting(FEEDBACK_LOADING, true))
);

export const hydrateFeedback = () => (
  receiveFeedbacks(getFAQFeedbackFromStorage())
);

type FaqFeedbackResponse = {|
  success: boolean,
|};

export const submitFAQFeedback = async (
  feedbackUrl: string,
  feedbackID: string,
  feedback: FeedbackOptions,
): Promise<boolean> => {
  const endpoint = getFAQFeedbackUrl();
  if (!endpoint) {
    throw new Error('No url provided');
  }

  const { json } = await fetchData({
    endpoint,
    method: 'POST',
    body: {
      feedback: feedbackMap[feedback] || feedback,
      permalink: feedbackUrl,
      post_id: feedbackID,
    },
  });
  const response: FaqFeedbackResponse = json;

  return response.success;
};

export const submitFAQFeedbackForCurrentPath = (feedback: FeedbackOptions) => (
  async (dispatch: Dispatch<any>, getState: () => *) => {
    const state = getState();
    const faqPathname = getPathname(state);
    const faqID = getId(state).toString();

    // We'll do fire and forget here: if server call fails, the UI should reflect
    // the right state
    dispatch(setFAQFeedback(faqID, feedback));

    try {
      await submitFAQFeedback(faqPathname, faqID, feedback);
    } catch (error) {
      console.error(error.message);
      throw error;
    }
  }
);


export default null;
